import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HistoricoPage } from '../historico/historico.page';
import { ServiciosService } from 'src/app/services/servicios.service';
import { PopoverController, AlertController, ToastController, IonSegment, LoadingController, Platform } from '@ionic/angular';
import { PopInfoComponent } from 'src/app/componentes/pop-info/pop-info.component';
import { Device} from '@ionic-native/device/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { Hotspot, HotspotNetwork } from '@ionic-native/hotspot/ngx';
import { AuthService } from 'src/app/services/auth.service';
import { Marcaje } from 'src/app/interfaces/marcaje';
import { environment } from 'src/environments/environment';
import { ModalController } from '@ionic/angular';
import { MultiEmpresaModalComponent } from 'src/app/componentes/modals/multiempresa-modal/multiempresa-modal.component';
import { SwPush } from '@angular/service-worker';
// tslint:disable

@Component({
  selector: 'app-marcaje',
  templateUrl: './marcaje.page.html',
  styleUrls: ['./marcaje.page.scss'],
})
export class MarcajePage implements OnInit {
  @ViewChild('selector') selector: any;
  id:number;
  controlTiempo:Boolean= false;
  motivos: any[] = [];
  historico : HistoricoPage;
  customPickerOptions: any;  
  customPicker: any;  
  fecha: Date = new Date();  
  marcaje : Marcaje = {
    id: null,
    codigoMotivo: null,
    fecha: null,
    fecha_time: null,
    empleado: null,
    nombreEmpleado: null,
    empresa: null,
    mensaje: null,
    motivo: null,
    finalizar_jornada: null
  };
  
  mensaje :any = {};  
  posicion: any = null;
  enEdicion: Boolean = false;
  wifis: any[] = [];
  fechaServicio:any;
  loading: any;
  isLoading: any = false;
  fecha_serv:any;
  diaHora: any;
  id_plataforma: any;
  sesionIniciada:Boolean = false;
  intervalo:any;
  datosIniciales: number = 1;
  aux:any;
  pausa:any;
  reanudacion: any;
  multiEmpresa: any[] = [];
  multiFinalizarJornada = false;

  @ViewChild(IonSegment) segment:IonSegment;
  @ViewChild(HistoricoPage) h: HistoricoPage;

  public codigoColor = environment.personalizado.codigoColor;

  constructor(private router: Router, 
              private rutaActiva:ActivatedRoute,
              private ser: ServiciosService,
              private popctrl: PopoverController,
              private alertCtrl: AlertController,
              private toast: ToastController,
              private dev: Device,
              private plat: Platform,
              private geo: Geolocation,
              private hotspot: Hotspot,
              private loadingCtrl: LoadingController,
              private auth: AuthService,
              private modalCtrl: ModalController,
              private swPush: SwPush
              ) {
      this.pausa = this.plat.pause.subscribe();
      this.reanudacion = this.plat.resume.subscribe(()=>{
        console.log('AQUI EL RESUMEN');
        this.auth.sigueEnSesion();
      })
                
      this.actualizaFecha();
    }
  ionViewWillUnload() {
    this.pausa.unsubscribe();
    this.reanudacion.unsubscribe();
  }
  ngOnInit() {   
    this.id = this.rutaActiva.snapshot.params.id;
    if(this.id > 0) {
      this.enEdicion = true;
    } else {
      this.enEdicion = false;
    }    
    this.marcaje.id = this.id;
    this.id_plataforma = localStorage.getItem('id_plataforma');               

    
    this.customPickerOptions = {
      buttons: [{
        text: 'Cancelar'        
      }, {
        text: 'Confirmar',
        handler: (event) => {          
          let tiempo_actual = new Date(this.marcaje.fecha_time);
          tiempo_actual.setHours(event.hour.value);
          tiempo_actual.setMinutes(event.minute.value);      
          this.marcaje.fecha_time = new Date(tiempo_actual);    
        }
      }]
    }
    this.customPicker = {
      buttons: [{
        text: 'Cancelar'
      }, {
        text: 'Confirmar',
        handler: (event) => {
          let tiempo_marcaje_ant = (new Date(this.marcaje.fecha_time));
          let tiempo_actual = new Date(this.marcaje.fecha_time);
          tiempo_actual.setMonth(event.month.value-1);
          tiempo_actual.setDate(event.day.value);          
          tiempo_actual.setFullYear(event.year.value);       
          tiempo_actual.setHours(tiempo_marcaje_ant.getHours());
          tiempo_actual.setMinutes(tiempo_marcaje_ant.getMinutes());
          this.marcaje.fecha_time = new Date(tiempo_actual);
        }
      }]
    }  
     
    if (this.plat.platforms().find((plata => plata.toUpperCase() === 'ANDROID'))) {
      this.hotspot.scanWifi().then((networks: HotspotNetwork[]) => {
        this.wifis = networks;
      });      
    }
    
    let watch = this.geo.watchPosition();
    watch.subscribe((data) => {    
      this.posicion = data;
    });  
    this.getMotivos();

    this.subscribeToNotifications();
  }

  /**
   * Obtenemos los datos de las distintas empresas del usuario.
   */
  async obtenerMultiEmpresa() {
    const multi_empresa = localStorage.getItem('multi_empresa');
    if (multi_empresa) {
      const empresas = multi_empresa.split(',');
      const promesasEmpresas = empresas.map(async empresa => {
        const res: any = await new Promise((resolve, reject) => {
          this.ser.getDatosEmpresas(empresa).subscribe({
            next: valor => resolve(valor),
            error: err => reject(err)
          });
        })
        return {
          id: res.id,
          imagen: `data:image/${res.formato.toLowerCase()};base64,` + res.imagen,
          titulo: res.titulo
        };
      });
      this.multiEmpresa = await Promise.all(promesasEmpresas);
      return ((this.multiEmpresa || []).length>0)?true:false;
    }
  }

  getMotivos() {     
    this.ser.getMotivos().subscribe((motivos:any) => {
      this.motivos = motivos;
    });
  }

  async ionViewWillEnter() { 
    this.auth.sigueEnSesion();
    const multi_empresa = localStorage.getItem('multi_empresa');

    if (multi_empresa) {
      let datosEmpresas = [];
      //this.marcaje.empresa = Number(localStorage.getItem('empresa_cloud'));
      await this.obtenerMultiEmpresa();
      datosEmpresas = await this.dameDatosEmpresas();
      if (this.id == 0){
        const marcaje = datosEmpresas.reduce((acc,act) => {
          if (act.mensaje.id == 5) {
            if (!acc.empresa){
              acc = act.marcaje;
            } else {
              if (act.marcaje.entrada == acc.entrada && act.marcaje.salida == acc.salida && act.marcaje.finalizar_jornada == acc.finalizar_jornada){
                if (new Date(acc.fecha_time).getTime() >= new Date(act.marcaje.fecha_time).getTime()) {
                  acc = act.marcaje;
                }
              } else if (act.marcaje.entrada == 1 && act.marcaje.salida == 2){
                acc = act.marcaje;
              }
            }
          } else {
            if(act.mensaje.id != 5) {
              this.presentAlert(act.mensaje.mensaje);
            }
          }
          return acc;
        },{});
        if(marcaje){
          this.setEmpresa(marcaje.empresa);
        } else {
          console.log(marcaje,'No coje nada');
        }
      } else {
        this.setMarcaje('');
      }
    } else {
      this.setMarcaje('');
    }
  }

  async dameDatosEmpresas() {
    let datosEmpresas = []
    await Promise.all(this.multiEmpresa.map(async empresa => {
      const datos = await this.dameDatosMarcajes(empresa.id);
      if (datos && datos.marcaje && datos.marcaje.mensaje) {
        empresa.mensaje = datos.marcaje.mensaje;
      }
      if (datos && datos.marcaje && datos.marcaje.finalizar_jornada == 2) {
        empresa.finalizar_jornada = datos.marcaje.finalizar_jornada;
        this.multiFinalizarJornada = true;
      }
      return datosEmpresas.push(datos);
    }));
    if (this.multiEmpresa.findIndex(empresa => empresa.finalizar_jornada == 2) == -1) {
      this.multiFinalizarJornada = false;
    }
    return datosEmpresas;
  }
  async dameDatosMarcajes(empresa:number){     
    let wifis = '';
    let latitud = '';
    let longitud = '';
    let marcaje = {...this.marcaje};
    marcaje.empresa = empresa;
    if (this.wifis.length > 0) {
      let wifiLimpia;
      for (let index = 0; index < this.wifis.length; index++) {
        wifiLimpia = this.limpiaCaracteres(this.wifis[index].SSID);
        if (this.wifis.length - 1 == index) {
          wifis += wifiLimpia;
        } else {
          wifis += wifiLimpia + '$';
        }
      }
    }
    try {    
      if ((this.posicion.coords != null) && (this.posicion.coords != undefined)) {
        latitud = this.posicion.coords.latitude;
        longitud = this.posicion.coords.longitude;
      }
    } catch (e) {
      console.log('Error', e);
    }
    let datosIniciales = 1;
    let plataforma = this.plat.platforms();
    let plat;
    for (let index = 0; index < plataforma.length; index++) {
      plat += plataforma[index]+';';        
    }
    let res:any = await new Promise((resolve, reject) => {
      this.ser.setInsertaMarcaje(marcaje, false, plat, '', wifis, latitud, longitud, datosIniciales).subscribe({
        next: men => {{
          resolve(men);
        }},
        error: err => {
          if(err.mensaje.id != 5) {
            this.presentAlert(err.mensaje.mensaje);
          }
          reject(err);
        }
      })
    });
    return res;
  }
  compruebaSession(){
    if(localStorage.getItem('empresa_cloud')!= null) {
      this.sesionIniciada = true;
    }else {
      this.sesionIniciada = false;
    }
  }
  asignaMotivo(valor) {

    this.marcaje.codigoMotivo = valor;       
    this.grabaMotivo(valor);    
  }
  grabaMotivo(id: number) {
    this.marcaje.motivo = '';    
    for (let index = 0; index < this.motivos.length; index++) {
      if(+this.motivos[index].id === id) {
        if(id===1) {
          this.marcaje.motivo = ' ';
        }else {          
          this.marcaje.motivo = this.motivos[index].motivo;
        }
      }      
    }
  }

  cancelarEdit() {
    //Si tengo id es porque estoy en edicion
    if(this.id > 0) {
      this.router.navigate(['/historico/'+this.marcaje.nombreEmpleado+'/'+this.marcaje.empleado]);
    }else {
      this.router.navigate(['/home']);
    }
  }
  limpiaCaracteres(palabra:any) {
    let palabraLimpia: string;
    try {      
      let vector:string[] = ['<','>','=','#','{','}','%','.','_','-'];
      palabraLimpia = palabra;
      for (let index = 0; index < vector.length; index++) { 
        palabraLimpia = palabraLimpia.replace(vector[index],'~');
      }
      
    } catch (ex) {
      console.error(ex);      
    }
    return palabraLimpia;
  }
  async setMarcaje(tipo:string, evento?:any){     
    this.controlTiempo = false;
    let controlaTiempo: any;
    let marcaje = {...this.marcaje}
    if(this.auth.sigueEnSesion()) {      
      await this.presentLoading('Cargando...');
      this.isLoading = true;
      let wifis = '';
      let latitud = '';
      let longitud = '';

      if (this.wifis.length > 0) {
        let wifiLimpia;
        for (let index = 0; index < this.wifis.length; index++) {
          wifiLimpia = this.limpiaCaracteres(this.wifis[index].SSID);
          if (this.wifis.length - 1 == index) {
            wifis += wifiLimpia;
          } else {
            wifis += wifiLimpia + '$';
          }
        }
      }
      try {    
        if ((this.posicion.coords != null) && (this.posicion.coords != undefined)) {
          latitud = this.posicion.coords.latitude;
          longitud = this.posicion.coords.longitude;
        }
      } catch (e) {
        console.log('Error', e);
      }
      if(evento != null) {
        this.datosIniciales = 0;
      }else {
        this.datosIniciales = 1;
      }      
      if (!marcaje.empresa){
        marcaje.empresa = Number(localStorage.getItem('empresa_cloud'));
      }
      let plataforma = this.plat.platforms();
      let plat;
      for (let index = 0; index < plataforma.length; index++) {
        plat += plataforma[index]+';';        
      }
      let subscripcion:any;
      subscripcion = this.ser.setInsertaMarcaje(marcaje, false, plat, tipo, wifis, latitud, longitud, this.datosIniciales).subscribe((men) => {
        this.controlTiempo = true;
        if(controlaTiempo) {
          clearInterval(controlaTiempo);
        }
        clearInterval(controlaTiempo);
        this.aux = men;
        if ((this.aux.id == 0) && (this.mensaje == null)){            
          this.presentAlert(this.aux.mensaje);
        }else {
          if ((this.aux.marcaje != null) && (this.aux.marcaje != undefined)) {                        
            this.mensaje = this.aux.mensaje;
            this.marcaje = null;
            if (this.aux.marcaje.nombreEmpleado <= '' || ((this.aux.marcaje.nombreEmpleado == null) || (this.aux.marcaje.nombreEmpleado == undefined) ))
            {
              if ((this.loading != null) && (this.loading != undefined)) {
                this.loading.dismiss();
                this.isLoading = false;
              } 
              this.presentAlert(this.mensaje.mensaje);
              this.sacameDeAqui();
            }else{
              this.marcaje = this.aux.marcaje;
              this.selector.value = +this.marcaje.codigoMotivo;
              this.asignaMotivo(this.marcaje.codigoMotivo);
              //this.grabaMotivo(this.marcaje.codigoMotivo);         
              if(environment.personalizado.logout && this.mensaje.id == 1) {
                this.auth.logout();
                // localStorage.clear();
                this.sacameDeAqui();
              }               
            }
          }else {              
            this.mensaje = this.aux;
          }
        }
        if ((this.loading != null) && (this.loading != undefined)) {
          this.loading.dismiss();
          this.isLoading = false;
        }      
        if(this.mensaje.id != 5) {
          this.presentAlert(this.mensaje.mensaje);
        }
      }, (error)=>{ 
        console.log('error', error);
        if (controlaTiempo) {
          clearInterval(controlaTiempo);
        }         
        if ((this.loading != null) && (this.loading != undefined)) {
          this.loading.dismiss();      
          this.isLoading = false;
          this.presentAlert('Error inesperado, por favor intentelo de nuevo pasados unos minutos');
        }
      });   
      controlaTiempo = setTimeout(() => {
      if (!this.controlTiempo) {
        subscripcion.unsubscribe();
        if ((this.loading != null) && (this.loading != undefined)) {
          this.loading.dismiss();
          this.isLoading = false;
        }
        this.presentAlert('La conexión esta tardando demasiado, por favor inténtelo de nuevo pasados unos momentos');
      }
    }, 1000 * 10);     
    }
  }

  async presentToast(message:string) {
    const toast = await this.toast.create({
      message,
      duration: 3000,
      position: 'bottom'
    });
    toast.present();
  }
  redirigir(event:any,pagina:string, tipo: number) {
    this.segment.value="blanco";
    let auxiliar;
    if (pagina == 'historico') {
      auxiliar = this.marcaje.empleado;
    } else {
      if(tipo == 1) {
        const empresa_orig = localStorage.getItem('empresa_orig');
        if (empresa_orig){
          this.getMotivos();
          this.auth.cambiaEmpresa(Number(empresa_orig));
        }
        auxiliar = 'password';
      }else {
        auxiliar = 'telefono';
      }
    }
    this.router.navigate(['/' + pagina + '/' + this.marcaje.nombreEmpleado+'/'+auxiliar]);
  }
  operacionFecha( fecha:any, operacion:number, tipo:number ){
    let tiempo;
    if(tipo == 1) {
      tiempo = 1000 * 60 * 60 * 24 * 1;
    } else 
    if(tipo == 2){
      tiempo = 1000 * 60 * 60 * 1;
    }
    let fecha_actual = new Date(this.marcaje.fecha_time);
    let nueva_fecha;
    if(operacion == 2) {
      nueva_fecha = fecha_actual.getTime() -  tiempo;
      this.marcaje.fecha_time = new Date(nueva_fecha);
    }else {
      nueva_fecha = fecha_actual.getTime() + tiempo;
      this.marcaje.fecha_time = new Date(nueva_fecha);
    }
  }
  operacionFechaHora(operacion: number, tipo: number){
    let tiempo;
    if (tipo == 1) {
      // 1 hora
      tiempo = 1000 * 60 * 60 * 1;
    } else
      if (tipo == 2) {
        // 1 minuto
        tiempo = 1000 * 60 * 1;
      }
    let fecha_actual = new Date(this.marcaje.fecha_time);
    let nueva_fecha;
    if (operacion == 2) {
      nueva_fecha = fecha_actual.getTime() - tiempo;
      this.marcaje.fecha_time = new Date(nueva_fecha);
    } else {
      nueva_fecha = fecha_actual.getTime() + tiempo;
      this.marcaje.fecha_time = new Date(nueva_fecha);
    }
  }
  async mostrarPop() {

    const popover = await this.popctrl.create({
      component: PopInfoComponent,      
      //mode: 'ios',
      backdropDismiss: false
    });

    await popover.present();
}
  async presentAlert(mensaje:string) {
    const alert = await this.alertCtrl.create({
      subHeader: mensaje,
      buttons: [{
        text: 'Ok',
        handler: () => {
          if(this.id > 0) {
            if (this.mensaje.id != 3) {
              this.router.navigate(['/historico/' + this.marcaje.nombreEmpleado + '/' + this.marcaje.empleado]);
            }   
          }else {
          }
        }
      }]
    });

    await alert.present();
  }

  async modalMultiEmpresa(mensaje:string,multiEmpresa:any = this.multiEmpresa) {
    const modal = await this.modalCtrl.create({
      component: MultiEmpresaModalComponent,
      componentProps: { multiEmpresa: multiEmpresa, texto: mensaje},
      cssClass: 'modal-pequeno'
    });
    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      return data;
    } else {
      return false;
    }
  }

  async presentLoading(message: string) {
    this.loading = await this.loadingCtrl.create({
      message
      // duration: 2000
    });
    return this.loading.present();
  }
  actualizaFecha() {
    this.diaHora = Date();
    setTimeout(() => {
      this.actualizaFecha();
    }, 1000);
  }
  async setFinalizaJornada(){
    //FALTA COMPROBAR LA VARIABLE multiFinalizarJornada == false, si es true hace cosa dif y mira multiempresa.falta_finalizar
    this.controlTiempo = false;
    let controlatiempo: any;
    if (this.auth.sigueEnSesion()) {
      if ((this.multiEmpresa || []).length>0 && this.multiFinalizarJornada == true) {
        const result = await this.modalMultiEmpresa('¿Donde quiere finalizar jornada?',this.multiEmpresa.filter(empresa=>empresa.finalizar_jornada==2));
        if (result){
          this.auth.cambiaEmpresa(result.id);
          this.marcaje.empresa = result.id;
        } else {
          return;
        }
      }
      await this.presentLoading('Cerrando jornada...');
      this.isLoading = true;
      let wifis = '';
      let latitud = '';
      let longitud = '';
      if (this.wifis.length > 0) {
        let wifiLimpia;
        for (let index = 0; index < this.wifis.length; index++) {
          wifiLimpia = this.limpiaCaracteres(this.wifis[index].SSID);
          if (this.wifis.length - 1 == index) {
            wifis += wifiLimpia;
          } else {
            wifis += wifiLimpia + '$';
          }
        }
      }
      try {
        if ((this.posicion != null) && (this.posicion != undefined)) {
          if ((this.posicion.coords != null) && (this.posicion.coords != undefined)) {
            latitud = this.posicion.coords.latitude;
            longitud = this.posicion.coords.longitude;
          }
        }
      } catch (e) {
        console.log('Error', e);
      }
      let plataforma = this.plat.platforms();
      let plat;
      for (let index = 0; index < plataforma.length; index++) {
        plat += plataforma[index] + ';';
      }
      let subscripcion = this.ser.setFinalizaJornada(this.marcaje, false, plat, 'S', wifis, latitud, longitud).subscribe((salida) => {        
        this.controlTiempo = true;
        clearInterval(controlatiempo);
        this.aux = salida;
        this.mensaje = this.aux.mensaje;
        this.marcaje = this.aux.marcaje;
        this.selector.value = +this.marcaje.codigoMotivo;
        this.asignaMotivo(this.marcaje.codigoMotivo);
        if ((this.loading != null) && (this.loading != undefined)) {
          this.loading.dismiss();
          this.isLoading=false;
        }
        if (this.mensaje.id != null) {
          this.presentAlert(this.mensaje.mensaje);
          if ((this.multiEmpresa || []).length>0 && this.multiFinalizarJornada == true) {
            this.setMarcaje('');
          }
        }
      }, (error) => {
        console.log('error',error);
        if (controlatiempo) {
          clearInterval(controlatiempo);
        }
        if ((this.loading != null) && (this.loading != undefined)) {
          this.loading.dismiss();
          this.isLoading=false;

          this.presentAlert('Error inesperado, por favor inténtelo de nuevo pasados unos minutos');
        }
      });      
      controlatiempo = setTimeout(() => {
        if (!this.controlTiempo) {
          subscripcion.unsubscribe();
          if ((this.loading != null) && (this.loading != undefined)) {
            this.loading.dismiss();
            this.isLoading=false;
          }
          this.presentAlert('La conexión esta tardando demasiado, por favor inténtelo de nuevo pasados unos minutos');
        }
      }, 1000 * 10);    
    }
  }
  abrirAyuda () {
    this.ser.abrirAyuda();
  }  
  sacameDeAqui(){
    this.router.navigate(['/home']);
  }
  setEmpresa(empresa:number){
    this.getMotivos();
    if (empresa) {
      this.auth.cambiaEmpresa(empresa);
      this.marcaje.empresa=empresa;
      this.setMarcaje('');
    }
  }
  async marcaEmpresa(empresa:number,tipo:string, evento?:any){
    if (empresa) {
      if (tipo == 'SE'){
        if (empresa != this.marcaje.empresa) {
          if (this.id == 0) {
            let oldMarcaje = {...this.marcaje};
            await this.setMarcaje('S',evento);
            while (this.isLoading) {
              await new Promise(resolve=>setTimeout(() => {
                if (!this.isLoading) {
                  this.auth.cambiaEmpresa(empresa);
                  this.marcaje = oldMarcaje;
                  this.marcaje.empresa = empresa;
                  this.setMarcaje('E',evento);
                }
                resolve(true);
  
              }, 1000))
            }
          } else {
            this.auth.cambiaEmpresa(empresa);
            this.marcaje.empresa = empresa;
            await this.setMarcaje('S',evento);
          }
        } else {
          console.log('Este caso no se dará nunca');
        }
      } else {
        this.auth.cambiaEmpresa(empresa);
        this.marcaje.empresa = empresa;
        this.setMarcaje(tipo,evento);
      }
    }
    await this.obtenerMultiEmpresa();
    this.dameDatosEmpresas();
  }

  subscribeToNotifications() {
    if ("Notification" in window) {
      console.log(Notification.permission);
      if (Notification.permission == 'denied') {
        // Este usuario no tiene las notificaciones activas.
      } else if (Notification.permission == 'granted') {
        // Chekear en BD si existe una notificación válida.
        // Si no existe volver a solicitar.
      } else {
        this.swPush.requestSubscription({
          // Key registrada con g2kmarcajes@gmail.com, Firebase proyecto pruebasSW
          // serverPublicKey: 'BPCCua9nRWrzaCTp-M5RbUoGsvkjYS5CtChhbvNJB_aH_jj2GGlN0kIFIpT3x-qgDjrbIpLZa7IS_odc1WZJzWU'
          serverPublicKey: 'BBnyWDlNEOzVZb0EQYZmyzbnqlPmWDY5T1Kz-GxF6CgFQLaW0juoVn2oF_bTsh77t0AFs4dBYk0vRWDorC0D1LM'
        })
        .then(sub => {
          console.log(sub);
          console.log('HOLAAAA');
          return this.ser.suscribNotificaciones(sub).subscribe();
        })
        .catch(err => console.error("Could not subscribe to notifications", err));
      }
    }
  }
}

